import { Box, Button, CircularProgress, Typography, } from '@mui/material';
import { Delete, Visibility, CheckCircle } from '@mui/icons-material';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import _ from 'lodash';
import { MUIDataTableColumnDef } from 'mui-datatables';
import React from 'react';
import MenuListComponent, { MenuListItem } from './menu-list/menu-list-component';
import DialogComponent from '../../component/dialog/dialog.component';

import GlobalNotification from '../../component/common/snackbar';
import Table from '../../component/table/table';
import { Condiments, FirstMenu, ItemUnit, ITEM_TYPE, MenuDish, SecondMenu, TaxGroup } from '../../models';

import { apiManage_rbp } from '../../request';
import ClassifyMenuDetail from './classify-menu-detail.component';
// css
import './scss/classify-menu-library.scss'
import i18n from '../../i18n';
import ButtonComponent from '../../component/button/button.component';

enum FilterBarType {
    ALL = 'ALL',
    UNCLASSIFY = 'UNCLASSIFY',
}

export default class ClassifyMenuLibrary extends React.Component<Props, State> {
    public filterBars = [
        { label: 'ALL', value: FilterBarType.ALL },
        // { label: '未归类', value: FilterBarType.UNCLASSIFY },
    ]

    public state: State = {
        // 是否加载中
        isLoading: false,
        // 基础菜品库列表
        classifyMenuItems: {
            classify: [],
            unclassify: [],
        },
        // 所有菜品
        totalMenuItems: [],
        // 当前显示的菜品列表
        dishesData: [],
        // 筛选bar类型 - 默认为 ALL
        showType: FilterBarType.ALL,
        // 是否显示菜品详情
        isShowMenuDishData: false,
        // 菜品详情
        detailData: {},
        // 二级菜单
        sluMenus: [],
        // 是否显示菜单列表弹窗
        isShowMenuListDialog: false,
        // 是否显示确认操作弹窗
        isShowConfirmDialog: false,
        // 选中的二级菜单ids - 复制用
        checkedSecondMenuIds: [],
        // 选中的菜品 - 复制用
        dishSelected: [],
        // 表格每页行数
        rowsPerPage: 20,
        // 当前页
        currPage: 0,
        // 当前选中的item
        rowsSelected: [],
    }
    // *********************
    // Life Cycle Function
    // *********************
    async componentDidMount() {
        await this.init()
    }

    // *********************
    // Default Function
    // *********************
    async init(loading: boolean = true) {
        const { menuData } = this.props
        // 显示动画
        this.setState({ isLoading: loading })
        const result = await apiManage_rbp.get_menu_library()
        if (_.get(result, 'error')) {
            GlobalNotification.error(i18n.t('menu_and_dishes_page_get_basic_dishes_list_failed'));
            this.setState({
                isLoading: false,
                dishesData: [],
            })
            return;
        }
        // 整合二级菜单
        let sluMenus: SecondMenu[] = [];
        if (!_.isEmpty(menuData)) {
            menuData.forEach(n => {
                if (n.menu_item_slu) {
                    const menuSlu = n.menu_item_slu.map(item => {
                        return {
                            ...item,
                            first_menu_name: n.main_group_name,
                        }
                    })
                    sluMenus = sluMenus.concat(menuSlu);
                }
            })
        }
        // TODO 未归类
        this.setState({
            classifyMenuItems: result || [],
            totalMenuItems: result || [],
        }, () => {
            // 当前显示的菜品数据
            const dishesData = this.setDishesDataByFilterBar();
            this.setState({
                dishesData,
                isLoading: false,
                sluMenus,
            })
        })
    }

    /**
     * TODO 批量导入菜品入菜品库（待对接OD）
     * 选中项，表格头部工具栏显示
     * @returns
     */
    public handleTableToolbarSelectRender(
        selectedRows: { data: Array<{ index: number; dataIndex: number }>; lookup: { [key: number]: boolean } }
    ): React.ReactNode {
        // 菜品数据
        const dishesData = _.cloneDeep(this.state.totalMenuItems ?? [])
        const dishSelected = selectedRows.data.map((item) => (dishesData[item.dataIndex]))
        // view
        return (
            <>
                <div style={{ padding: '4px 12px', }}>
                    <ButtonComponent
                        titleText={i18n.t('menu_and_dishes_page_copy_dishes')}
                        handleClick={() => {
                            this.setState({
                                dishSelected,
                            }, () => {
                                this.handleMenuListDialogShow(true);
                            })
                        }}
                    >
                        <FileCopyOutlinedIcon />
                    </ButtonComponent>
                    <ButtonComponent
                        titleText={i18n.t('menu_and_dishes_page_delete_dish')}
                        handleClick={() => {
                            this.setState({
                                dishSelected,
                                isShowConfirmDialog: true,
                            })
                        }}
                    >
                        <Delete />
                    </ButtonComponent>
                </div>
            </>
        )
    }

    /**
     * 筛选bar点击事件
     * @param value
     * @returns
     */
    onClickFilterBar = (value: FilterBarType) => {
        this.setState({
            showType: value
        }, () => {
            const dishesData = this.setDishesDataByFilterBar();
            this.setState({
                dishesData,
            })
        })
    }

    /**
     * 筛选当前菜品数据
     * - 根据筛选bar
     * @returns
     */
    setDishesDataByFilterBar = (): MenuDish[] => {
        const { showType, totalMenuItems, classifyMenuItems } = this.state
        let currentDishsData = this.state.dishesData
        switch (showType) {
            case FilterBarType.ALL:
                currentDishsData = totalMenuItems;
                break;
            case FilterBarType.UNCLASSIFY:
                currentDishsData = classifyMenuItems?.unclassify || [];
                break;
        }

        return currentDishsData
    }

    /**
     * 新增基础菜品
     * @returns
     */
    onCreate = () => {
        // TODO 新增套餐菜品
        this.setState({
            isShowMenuDishData: true,
            detailData: {
                item_name1: 'Unnamed',
                item_name2: 'Unnamed',
                item_type: 0,
            },
        })
    }

    /**
     * 控制菜单列表对话框显示
     * @param open
     */
    public handleMenuListDialogShow(open: boolean,) {
        this.setState({
            isShowMenuListDialog: open,
            checkedSecondMenuIds: [],
        })
    }

    /**
     * 点击菜单
     * @param menuData
     * @param index
     */
    public handleClick(menuData: MenuListItem) {
        // 二级菜单
        if (!menuData.children) {
            this.handleCheckBoxChange(menuData)
        }
    }

    /**
     * checkBox控制事件 （仅针对二级菜单）
     * @param menu
     */
    public handleCheckBoxChange(menu: MenuListItem) {
        const { checkedSecondMenuIds, } = this.state
        const menuId = _.get(menu, 'dataSource.dmi_slu_id')
        const filterIndex = checkedSecondMenuIds.findIndex((item) => {
            return item === menuId
        })
        // 复制菜品操作 （可多选）
        if (filterIndex === -1) {
            checkedSecondMenuIds.push(menuId)
        } else {
            checkedSecondMenuIds.splice(filterIndex, 1)
        }
        this.setState({
            checkedSecondMenuIds,
        })
    }

    /**
     * 删除菜品操作
     * @returns
     */
    public async deleteDishesAction() {
        const { dishSelected } = this.state
        const dishIds = dishSelected.map((dish: MenuDish) => {
            return (dish.id as number)
        })
        // $ 请求接口
        const result = await apiManage_rbp.delete_menu_library(dishIds);
        // 修改成功
        if (!_.get(result, 'error')) {
            GlobalNotification.success(i18n.t('global_text_operate_success'));
            await this.init(false);
        }
        else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
        }
        // 删除菜品数据时一起删除上一次保存的菜品图片
        // await Promise.all(dishIds.map(id => apiManage_rbp.delete_dishes_image(id)));
        this.setState({
            isShowConfirmDialog: false,
            dishSelected: [],
            rowsSelected: [],
        })
    }

    /**
     * 菜单列表对话框
     * @returns
     */
    public renderMenuListDialog(): JSX.Element {
        const { menuData } = this.props
        const { isShowMenuListDialog, checkedSecondMenuIds, } = this.state
        // 左侧菜单
        // $ 对话框内的菜单可多选，新增checkedSecondMenuIds字段
        const menu = menuData.map((item) => ({
            key: `${item.main_group_id}`,
            title: item.main_group_name ?? '',
            children: (item.menu_item_slu || []).map((subMenuItem) => ({
                key: `sub-${subMenuItem.dmi_slu_id}`,
                title: subMenuItem.dmi_slu_name ?? '',
                dataSource: subMenuItem,
                checkedSecondMenuIds,
                originId: subMenuItem.dmi_slu_id,
            })),
            dataSource: item,
        }))
        return (
            <DialogComponent
                defaultHeaderProps={{
                    title: i18n.t('menu_and_dishes_page_copy_dishes'),
                    onClose: () => {
                        this.handleMenuListDialogShow(false)
                    }
                }}
                open={isShowMenuListDialog}
                fullWidth={true}
                maxWidth={'sm'}
                scroll={'paper'}
                onClose={() => {
                    this.handleMenuListDialogShow(false)
                }}
                footer={
                    <div>
                        <Button
                            color='primary'
                            variant='outlined'
                            onClick={() => {
                                this.handleMenuListDialogShow(false)
                            }}
                        >{i18n.t('google_text_public_button_cancel')}</Button>
                        <Box marginLeft={4} display='inline-block'>
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={() => {
                                    this.onConfirm()
                                }}
                            >{i18n.t('google_text_confirm')}</Button>
                        </Box>
                    </div>}
            >
                <MenuListComponent
                    fullWidth
                    isHideContextMenu={true}
                    menu={menu}
                    isShowCheckBox={true}
                    handleClick={(menu: MenuListItem,) => {
                        this.handleClick(menu,)
                    }}
                />
            </DialogComponent>
        )
    }

    /**
     * 复制、转移菜品确认事件
     * @returns
     */
    public async onConfirm() {
        const { dishSelected, checkedSecondMenuIds, } = this.state
        // 删除部分字段
        const afterDishSelected = dishSelected.map(n => {
            const obj = {
                slu_id: n.slu_id,
                allergen: n.allergen,
                bargain_stype: n.bargain_stype,
                discount_itemizer: n.discount_itemizer,
                item_description: n.item_description,
                dmi_slu_id: n.dmi_slu_id,
                item_id: n.item_id,
                item_name1: n.item_name1,
                item_name2: n.item_name2,
                not_joining_global_limit: n.not_joining_global_limit,
                print_class: n.print_class,
                print_device: n.print_device,
                quantity: n.quantity,
                rule_lnr_enable: n.rule_lnr_enable,
                rule_lnr_limit_enable: n.rule_lnr_limit_enable,
                rule_lnr_limit_price: n.rule_lnr_limit_price,
                rule_lnr_max_num: n.rule_lnr_max_num,
                rule_table_max_num: n.rule_table_max_num,
                rule_lnr_max_num_with_customer: n.rule_lnr_max_num_with_customer,
                service_itemizer: n.service_itemizer,
                weight_entry_required: n.weight_entry_required,
                ext_dish_info: n.ext_dish_info,
                other_detail_info: n.other_detail_info,
                foodImage: n.foodImage,
                bigFoodImage: n.bigFoodImage,
                condiments: n.condiments,
                item_type: n.item_type,
                customers: n.customers,
                familyDishTotalCount: n.familyDishTotalCount,
                origin_id: n.origin_id,
                category_order_limit: n.category_order_limit,
                nlu: n.nlu,
                rules_ignore_the_display: n.rules_ignore_the_display,
                tax_group: n.tax_group,
                scomdiment_groups_id: n.scomdiment_groups_id,
                comdiment_groups_name: n.comdiment_groups_name,
                unit_1: n.unit_1,
                price_1: n.price_1,
                takeout_price_1: n.takeout_price_1,
                unit_2: n.unit_2,
                price_2: n.price_2,
                takeout_price_2: n.takeout_price_2,
                unit_3: n.unit_3,
                price_3: n.price_3,
                takeout_price_3: n.takeout_price_3,
                unit_4: n.unit_4,
                price_4: n.price_4,
                takeout_price_4: n.takeout_price_4,
                unit_5: n.unit_5,
                price_5: n.price_5,
                takeout_price_5: n.takeout_price_5,
                menu_item_id: n.menu_item_id,
                id: n.id,
                // 原来的二级菜单id
                slu_ids: n.slu_ids,
                // 修改后的二级菜单id
                new_ids: `${n.slu_ids || ''},${checkedSecondMenuIds.join(',')}`,
                // 原来的菜品id
                item_ids: n.item_ids,
                required_condiment: n.required_condiment,
            }
            return obj
        })
        // $ 批量复制菜品
        // 组合参数
        const params: {
            menus_arr: Array<MenuDish>,
            slu_ids: number[]
        } = {
            menus_arr: afterDishSelected,
            slu_ids: checkedSecondMenuIds,
        }
        const result = await apiManage_rbp.patch_menu_library_to_menus(params);
        if (!_.get(result, 'error')) {
            GlobalNotification.success(i18n.t('global_text_operate_success'));
            // 刷新菜单菜品制作器数据
            this.props.getMenuData();
        } else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
        }
        this.setState({
            isShowMenuListDialog: false,
        })
    }

    /**
     * 确认操作对话框
     * @returns
     */
    public renderConfirmDialog(): JSX.Element {
        const { isShowConfirmDialog } = this.state

        return (
            <DialogComponent
                defaultHeaderProps={{
                    title: i18n.t('menu_and_dishes_page_delete_dish'),
                    onClose: () => {
                        this.setState({ isShowConfirmDialog: false });
                    }
                }}
                open={isShowConfirmDialog}
                fullWidth={true}
                maxWidth={'xs'}
                onClose={() => {
                    this.setState({ isShowConfirmDialog: false });
                }}
                footer={
                    <div>
                        <Button
                            color='primary'
                            variant='outlined'
                            onClick={() => {
                                this.setState({ isShowConfirmDialog: false });

                            }}
                        >{i18n.t('google_text_public_button_cancel')}</Button>
                        <Box marginLeft={4} display='inline-block'>
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={async () => {
                                    await this.deleteDishesAction()
                                }}
                            >{i18n.t('google_text_confirm')}</Button>
                        </Box>
                    </div>}
            >
                <span>{i18n.t('dinner_table_page_whether_confirm_delete')}</span>
            </DialogComponent>
        )
    }

    // *********************
    // View
    // *********************

    render() {
        const { onCancel, open, menuData, getMenuData, taxGroup, condimentsGroup, printGroup, disableEdit, onFtConfirm, priceSpecList } = this.props;
        const { dishesData, isShowMenuDishData, detailData, isLoading, sluMenus, rowsPerPage } = this.state

        const columns: MUIDataTableColumnDef[] = [
            {
                name: 'id',
                label: i18n.t('menu_and_dishes_page_dish_id'),
            },
            {
                name: 'item_name1',
                label: i18n.t('base_setting_dish_name'),
            },
            {
                name: 'price_1',
                label: i18n.t('menu_and_dishes_page_dish_price'),
            },
            {
                name: 'item_type',
                label: i18n.t('menu_and_dishes_page_dish_type'),
                options: {
                    searchable: false,
                    customBodyRenderLite: (dataIndex: number) => {
                        const itemType = ITEM_TYPE.find((item) => item.value === dishesData[dataIndex].item_type);
                        return (
                            <Typography variant='subtitle1' >
                                {itemType?.label || ''}
                            </Typography>
                        )
                    }
                }
            },
            {
                name: 'action',
                label: disableEdit ? i18n.t('cash_box_page_operation') : i18n.t('google_text_check_detail'),
                options: {
                    sort: false,
                    download: false,
                    searchable: false,
                    customBodyRenderLite: (dataIndex: number) => {
                        // 当前菜品详情数据
                        const currentMenuDishData = dishesData[dataIndex];
                        // 选中标识
                        const selectFlag: boolean = currentMenuDishData.id === detailData?.id
                        return (
                            <>
                                {
                                    disableEdit ?
                                        <Box width={100}>
                                            <ButtonComponent titleText={i18n.t('google_text_select')} handleClick={() => {
                                                this.setState({
                                                    detailData: selectFlag ? {} : currentMenuDishData,
                                                })
                                            }}
                                                iconBtn={false}
                                            >
                                                {
                                                    selectFlag ?
                                                        <div className='FC'>
                                                            <CheckCircle />
                                                            <span>{i18n.t('google_text_selected')}</span>
                                                        </div>
                                                        :
                                                        i18n.t('google_text_select')
                                                }
                                            </ButtonComponent>
                                        </Box>
                                        :
                                        <ButtonComponent action='VIEW' handleClick={() => {
                                            // 当前菜品详情数据
                                            const currentMenuDishData = dishesData[dataIndex]
                                            this.setState({
                                                isShowMenuDishData: true,
                                                detailData: currentMenuDishData,
                                            })
                                        }}>
                                            <Visibility />
                                        </ButtonComponent>
                                }
                            </>

                        )
                    }
                }
            }
        ]

        return (
            <DialogComponent
                open={open}
                defaultHeaderProps={{
                    title: i18n.t('menu_and_dishes_page_basic_dishes_list'),
                    onClose: onCancel,
                }}
                footer={
                    disableEdit ?
                        <div>
                            <Button
                                color='primary'
                                variant='outlined'
                                onClick={onCancel}
                            >{i18n.t('google_text_public_button_cancel')}</Button>
                            <Box marginLeft={4} display='inline-block'>
                                <Button
                                    color='primary'
                                    variant='contained'
                                    onClick={() => onFtConfirm?.(detailData as MenuDish)}
                                >{i18n.t('google_text_confirm')}</Button>
                            </Box>
                        </div>
                        : <></>
                }
            >
                {
                    isLoading ?
                        <div style={{
                            display: 'flex',
                            height: '80vh',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                            <CircularProgress color='primary' />
                        </div>
                        :
                        <Box className='menu-library-page'>
                            {/* 头部 */}
                            {
                                !disableEdit &&
                                <Box className='FCB'>
                                    <Box flex={1}>
                                        {!isShowMenuDishData &&
                                            <ButtonComponent
                                                titleText={i18n.t('google_text_newly_increased')}
                                                action='ADD'
                                                handleClick={() => { this.onCreate() }}
                                                buttonStyle={{ marginBottom: '8px' }}
                                            />}
                                    </Box>
                                    {/* // TODO 筛选未归类、沽清等 */}
                                    {/* <Grid container spacing={2} wrap='nowrap' className='menu-library-header'>
                                        {
                                            this.filterBars.map((item, index) => {
                                                return (
                                                    <Grid key={index} item className={`filter-btn ${showType === item.value ? 'selected-btn' : ''}`}>
                                                        <ButtonComponent
                                                            titleText={item.label}
                                                            handleClick={() => {
                                                                this.onClickFilterBar(item.value)
                                                            }}
                                                            children={item.label}
                                                        />
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid> */}
                                </Box>
                            }
                            {
                                !isShowMenuDishData ?
                                    <Table
                                        data={dishesData}
                                        columns={columns}
                                        search={true}
                                        selectToolbarPlacement={'replace'}
                                        selectableRowsHideCheckboxes={!!disableEdit}
                                        selectableRowsHeader={true}
                                        pagination={true}
                                        rowsPerPage={rowsPerPage}
                                        onChangeRowsPerPage={(nums: number) => {
                                            this.setState({
                                                rowsPerPage: nums,
                                            })
                                        }}
                                        onRowSelectionChange={(currentRowsSelected: any[], allRowsSelected: any[], rowsSelected?: any[]) => {
                                            this.setState({
                                                rowsSelected: rowsSelected || []
                                            })
                                        }}
                                        rowsSelected={this.state.rowsSelected}
                                        selectableRowsOnClick={!disableEdit}
                                        customToolbarSelect={(
                                            selectedRows,
                                        ): React.ReactNode => {
                                            if (disableEdit) {
                                                return;
                                            } else {
                                                return this.handleTableToolbarSelectRender(selectedRows);
                                            }
                                        }}
                                        otherOption={{
                                            viewColumns: true,
                                            page: this.state.currPage,
                                            onChangePage: (page: number) => {
                                                this.setState({ currPage: page })
                                            },
                                        }}
                                    />
                                    :
                                    // 菜品详情
                                    <ClassifyMenuDetail
                                        menuData={menuData}
                                        sluMenus={sluMenus}
                                        detail={detailData as MenuDish}
                                        handleClickBack={() => {
                                            this.setState({
                                                isShowMenuDishData: false,
                                                detailData: undefined,
                                            }, async () => {
                                                await this.init()
                                            })
                                        }}
                                        getMenuData={getMenuData}
                                        updateDetail={(menuDish) => {
                                            this.setState({
                                                detailData: menuDish
                                            })
                                        }}
                                        taxGroup={taxGroup}
                                        condimentsGroup={condimentsGroup}
                                        printGroup={printGroup}
                                        priceSpecList={priceSpecList}
                                    />
                            }
                            {/* 菜品列表对话框 */}
                            {this.renderMenuListDialog()}
                            {/* 确认操作对话框 */}
                            {this.renderConfirmDialog()}
                        </Box>
                }
            </DialogComponent>
        )
    }
}

// *********************
// Type
// *********************
type Props = {
    // 开关
    open: boolean;
    // 取消
    onCancel: () => void;
    // 刷新菜单数据
    getMenuData: () => void;
    // 菜单源数据
    menuData: FirstMenu[];
    // 税率组
    taxGroup: TaxGroup[];
    // 调味品组
    condimentsGroup: Condiments[];
    // 打印组(岗位)
    printGroup: any[];
    // 禁止编辑
    disableEdit?: boolean;
    // 菜品规格列表
    priceSpecList: ItemUnit[];
    // 底部确认
    onFtConfirm?: (detailData: MenuDish) => void;
}
type State = {
    // 是否加载中
    isLoading: boolean;
    // 基础菜品库列表
    classifyMenuItems: {
        classify: MenuDish[],
        unclassify: MenuDish[],
    };
    // 所有菜品
    totalMenuItems: MenuDish[];
    // 当前显示的菜品列表
    dishesData: MenuDish[];
    // 筛选bar类型
    showType: FilterBarType;
    // 是否显示菜品详情
    isShowMenuDishData: boolean;
    // 菜品详情
    detailData: MenuDish | undefined;
    // 二级菜单
    sluMenus: SecondMenu[];
    // 是否显示菜单列表弹窗
    isShowMenuListDialog: boolean;
    // 是否显示确认操作弹窗
    isShowConfirmDialog: boolean;
    // 选中的二级菜单ids - 复制用
    checkedSecondMenuIds: number[];
    // 选中的菜品 - 复制用
    dishSelected: MenuDish[],
    // 表格每页行数
    rowsPerPage: number;
    // 当前页
    currPage: number;
    // 当前选中的item
    rowsSelected: number[];
}